<template>
    <div id="dealCurrentLease">
      <div v-if="!editMode" v-show="defaultValue != null && defaultValue != '~'">
        <div class="editRow" v-show="showEditButton">
          <div class="editBtn" @click="toEditMode">
            <pt-icon type="icon-bianji1" class="editIcon"></pt-icon>
          </div>
        </div>
        <div class="mansionDiv">
          <div class="mansionLeft">
            <div class="mansionLabelRow">
              <div class="mansionLabel" style="width: 30%;text-align: center;">{{$t('deal.addDeal.leaseContract.mansionName')}}</div>
              <div class="mansionLabel" style="width: 25%;padding-left: 20px;">{{$t('deal.addDeal.leaseContract.floor')}}</div>
              <div class="mansionLabel" style="width: 25%;">{{$t('deal.addDeal.leaseContract.unitCode')}}</div>
              <div class="mansionLabel" style="width: 20%;">{{$t('deal.addDeal.leaseContract.area')}}</div>
            </div>
            <div style="display: flex;flex-direction: row;">
              <div class="mansionImg" style="display: flex; align-items: center;">
<!--                <img v-if="defaultValue.mansionHeadImg != '0'" :src="getMansionUrl(defaultValue.mansionHeadImg)"/>-->
<!--                <img v-else src="../../../assets/defulat/mansion.png"/>-->
                <div class="mansionInfoText">{{defaultValue.mansionName}}</div>
              </div>
              <div class="floors" style="width: 70%;">
                <div v-for="(floor,index) in defaultValue.leaseLeaseInfoDetailsVOList" :key="index" class="mansionInfoRow">
                  <div class="mansionInfoText" style="padding-left: 20px;width: 35%;">{{floor.floorNum}}</div>
                  <div class="mansionInfoText" style="width: 35%;">{{floor.unitCodes}}</div>
                  <div class="mansionInfoText" style="width: 30%;">
                    {{floor.areaSize}}{{defaultValue.areaUnitStr}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mansionRight">
            <div class="mansionRightRow">{{$t('deal.addDeal.leaseContract.totalArea')}}</div>
            <div class="totalAreaDiv">
              {{defaultValue.leaseArea}}{{defaultValue.areaUnitStr}}
            </div>
          </div>
        </div>
        <div style="flex: 1;padding: 20px;">
          <a-row class="info_lines">
            <a-col :span="8" class="title">
              <div>{{$t('deal.addDeal.leaseContract.rent')}}({{defaultValue.rentUnitStr}})</div>
            </a-col>
            <a-col :span="8" class="title">
              <div>{{$t('deal.addDeal.leaseContract.increasing')}}</div>
            </a-col>
            <a-col :span="8" class="title">
              <div>{{$t('deal.addDeal.leaseContract.rentFreePeriod')}}</div>
            </a-col>
            <a-col :span="8" class="content">
              {{defaultValue.rent}}
            </a-col>
            <a-col :span="8" class="content">
              {{defaultValue.dueDatePrice}}
            </a-col>
            <a-col :span="8" class="content">
              {{defaultValue.rentFreePeriod}}
            </a-col>
          </a-row>
          <a-row class="info_lines">
            <a-col :span="8" class="title">
              <div>{{$t('deal.addDeal.leaseContract.signTime')}}</div>
            </a-col>
            <a-col :span="8" class="title">
              <div>{{$t('deal.addDeal.leaseContract.rentPeriod')}}</div>
            </a-col>
            <a-col :span="8" class="title">
              <div>{{$t('deal.addDeal.leaseContract.agent')}}</div>
            </a-col>
            <a-col :span="8" class="content">
              {{defaultValue.signTime | dayjs('YYYY-MM')}}
            </a-col>
            <a-col :span="8" class="content">
              {{$utils.format(defaultValue.startTime,'YYYY-MM')}} ~ {{$utils.format(defaultValue.endTime,'YYYY-MM')}}
            </a-col>
            <a-col :span="8" class="content">
              {{defaultValue.agentName}}
            </a-col>
          </a-row>
          <a-row>
            <!--<a-col :span="8" class="title">-->
              <!--<div>{{$t('deal.addDeal.dealDetails.competitionSituation')}}</div>-->
            <!--</a-col>-->
            <a-col :span="8" class="title">
              <div>{{$t('deal.addDeal.dealDetails.remarks')}}</div>
            </a-col>
          </a-row>
          <a-row class="info_lines">
            <!--<a-col :span="8" v-if="defaultValue.colleagueDOS && defaultValue.colleagueDOS.length > 0">-->
              <!--<div v-for="c in defaultValue.colleagueDOS" :key="c.id" class="content">{{c.companyName}}</div>-->
            <!--</a-col>-->
            <!--<a-col :span="8" v-else>-->
              <!--~-->
            <!--</a-col>-->
            <a-col :span="24">
              <div class="content">{{defaultValue.remarks}}</div>
            </a-col>
          </a-row>
          <a-row>
            <span style="font-size: 12px;color:#999999">{{$t('lease.modal.files')}}</span>
            <a-divider style="margin: 10px;"></a-divider>
            <div class="fileDiv">
              <div v-if="defaultValue.fileDOList && defaultValue.fileDOList.length > 0">
                <div v-for="(item,index) in defaultValue.fileDOList" :key="index" class="fileItem">
                  <pt-icon type="icon-fujian2" class="fileIcon"></pt-icon>
                  <div class="fileName">{{item.fileName}}</div>
                  <div @click="previewFile(item)"  v-if="$util.matchPreviewType(item.fileName)" style="margin-right: 20px">
                    <pt-icon class="downloadIcon" type="icon-yulancopy" :title="$t('baseVO.preview')"></pt-icon>
                  </div>
                  <div @click="downloadFile(item)">
                    <pt-icon class="downloadIcon" type="icon-xiazai" :title="$t('baseVO.download')"></pt-icon>
                  </div>
                </div>
              </div>
              <div v-else class="noFileClass">
                <div>{{$t('leaveRecords.tips.emptyFile')}}</div>
                <!--<pt-empty><span slot="description"></span></pt-empty>-->
              </div>
            </div>
          </a-row>
        </div>
      </div>
      <div v-else>
        <div style="display: flex; justify-content: flex-end;margin: 5px 16px;" v-show="showEditButton">
          <a-button @click="hideLease" style="margin-right: 10px;" size="small">{{$t('baseVO.cacel')}}</a-button>
          <a-button @click="saveLease" type="primary" size="small">{{$t('baseVO.save')}}</a-button>
        </div>
        <addLease ref="dealAddLeaseRef" :leaseId="defaultValue.id" @saveSuccess="refreshLease"
          :defaultAreaUnit="defaultAreaUnit"
        ></addLease>
      </div>
    </div>
</template>

<script>
  import dealApi from '@/api/mine/deal'
  import pursuitsApi from '@/api/mine/pursuit'
  import addLease from '@/views/database/lease/module/addLease'
  import colleagueApi from '@/api/database/colleague'
  import { getByCompanyIdAndType, unitTypeEnum } from '@/api/manager/unitUse'

  export default {
    name: 'dealCurrentLease',
    components:{addLease},
    props:{
      hideEdit:{
        type:Boolean,
        default:false,
      },
      defaultValue:{
        type: Object,
        default: ()=>{
          return {}
        }
      },
      api:{
        type:String,
        default:'deal'
      },
      showEditButton:{
        type:Boolean,
        default: true
      }
    },
    computed:{
      areaUnit(){
        if(this.defaultValue.leaseLeaseInfoDetailsVOList){
          if(this.defaultValue.leaseLeaseInfoDetailsVOList.length > 0){
            return this.defaultValue.leaseLeaseInfoDetailsVOList[0].areaSizeUnit
          }
        }
      },
      totalAreaSize(){
        if(this.defaultValue.leaseLeaseInfoDetailsVOList){
          if(this.defaultValue.leaseLeaseInfoDetailsVOList.length > 0){
            let total = 0
            this.defaultValue.leaseLeaseInfoDetailsVOList.forEach(e=>{
              total += e.areaSize
            })
            return total
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
    },
    data(){
      return {
        agentDO: {},
        editMode:false,
        defaultAreaUnit:null,
        form: this.$form.createForm(this,{}),
        decorators:{
          mansion:['mansion',{rules:[],initialValue:null}],
          floor:['floor',{rules:[],initialValue:null}],
          unitCode:['unitCode',{rules:[],initialValue:null}],
          leaseArea:['leaseArea',{rules:[],initialValue:null}],
          rent:['rent',{rules:[],initialValue:null}],
          startTime:['startTime',{rules:[],initialValue:null}],
          endTime:['endTime',{rules:[],initialValue:null}],
          propertyType:['propertyType',{rules:[],initialValue:null}],
        }
      }
    },
    watch:{
      defaultValue(){
        this.init()
      },
    },
    mounted(){
      this.init()
    },
    methods:{
      previewFile(file){
        this.$util.previewFile(file.id)
      },
      downloadFile(file){
        this.$util.dowLoadFile(file.id,file.fileName,this);
      },
      getMansionUrl(fileId){
        let url = this.$util.getFileUrl(fileId);
        return url;
      },
      cancelEditMode(){
        this.editMode = false
      },
      extractLeaseInfoVO(){
        return this.$refs.dealAddLeaseRef.extractLeaseInfoVO()
      },
      init(){
        if(!this.defaultValue || this.defaultValue == '~' || !this.defaultValue.agent || this.defaultValue.agent == 0){
          return
        }
        colleagueApi.selectOne(this.defaultValue.agent).then(res=>{
          if(res.code == 1){
            this.agentDO = res.data
          }
        })
        this.initDefaultAreaUnit()
      },
      initDefaultAreaUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.AREA).then(res=>{
            if(res.code == 1){
              this.defaultAreaUnit = res.data[0]
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      toEditMode(){
        this.editMode = true
      },
      toViewMode(){
        this.editMode = false
      },
      hideLease(){
        this.editMode = false
      },
      refreshLease(){
        this.$emit('refreshLease')
        this.hideLease()
      },
      saveLease(){
        this.$refs.dealAddLeaseRef.submit()
      },
      // submit(){
      //   let submitObject = this.form.getFieldsValue()
      //   submitObject.id = this.defaultValue.id
      //   submitObject.depId = this.defaultValue.depId
      //   submitObject.version = this.defaultValue.version
      //   let api;
      //   if(this.api == 'deal'){
      //     api = dealApi
      //   }else if(this.api == 'pursuits'){
      //     api = pursuitsApi
      //   }else if(this.api == 'lease'){
      //     api = leaseApi
      //   }
      //   api.updateCurrentLease(submitObject).then(res=>{
      //     if(res.code == 1){
      //       this.$message.success(res.message)
      //       this.editMode = false
      //       this.$emit('saveSuccess')
      //     }else{
      //       this.$message.error(res.message)
      //     }
      //   })
      // }
    }
  }
</script>

<style scoped lang="less">
  #dealCurrentLease{
    .fileDiv{
      padding: 0 10px;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
    }
    .fileItem{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #E7E7E7;
      .fileIcon{
        font-size: 18px;
      }
      .fileName{
        flex:1;
        font-size: 12px;
        color: #333333;
        margin: 0 10px;
      }
      .downloadIcon{
        font-size: 16px;
      }
      .delIcon{
        font-size: 16px;
        cursor: pointer;
      }
    }
    .fileItem:last-child{
      border-bottom: 0px;
    }
    .noFileClass{
      padding: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #999999;
    }
    .mansionDiv{
      display: flex;
      flex-direction: row;
      margin: 20px 16px 0 16px;
      background: #F2F2F3;
      .mansionLeft{
        width: 70%;
        display: flex;
        flex-direction: column;
        border-right: 5px solid #ffffff;
        padding-top: 10px;
      }
      .mansionLabelRow{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #FFFFFF;
        padding-bottom: 10px;
      }
      .mansionLabel{
        font-size: 12px;
        color: #999999;
      }
      .mansionImg{
        min-height: 60px;
        img{
          width: 40px;
          height: 40px;
        }
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-right: 1px solid #FFFFFF;
      }
      .floors{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .mansionInfoRow{
        padding-left: 10px;
        min-height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid #FFFFFF;
      }
      .mansionInfoRow:last-child{
        border-bottom: 0;
      }
      .mansionInfoText{
        font-size: 12px;
        color: #333333;
      }
      .mansionRight{
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        .mansionRightRow{
          display: flex;
          justify-content: center;
          border-bottom: 1px solid #FFFFFF;
          padding-bottom: 7px;
        }
        .totalAreaDiv{
          font-size: 16px;
          color: #333333;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        }
      }
    }
    .editRow{
      display: flex;
      justify-content: flex-end;
      margin: 5px 16px 0 5px;
      .editBtn{
        cursor: pointer;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        .editIcon{
          font-size: 16px;
          color: #8E8E8E;
        }
      }
    }
    .customer_name{
      font-size: 17px;
      color: #333333;
      margin-bottom: 10px;
      font-weight: bold;
    }
    .info_lines{
      margin-bottom: 15px;
    }
    .title{
      font-size: 12px;
      color: #999999;
    }
    .content{
      font-size: 12px;
      color: #333333;
    }
    .save_buttons{
      display: flex;
      justify-content: flex-end;
      padding-top: 5px;
    }
    .save_form{
      padding: 18px 10px 0 10px;
    }
    .ant-form-vertical .ant-form-item{
      padding: 0 10px;
    }

  }
</style>